import React from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import { Card, CardHeader, CardActions, CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import {withRouter} from 'react-router'
import { byTitle } from "../reducer";
import {adminCardStyle} from '../containers/AdminHomepage';
import { saveCategoryTranslation } from '../actions/translation';
import {pushTranslation} from '../actions/sync'

class TrCategories extends React.Component {
  constructor(props) {
    super();
    this.state = {}
  }

  render() {
    return (
      <Card style={adminCardStyle}>
        <CardHeader
          title="Category Translation"
        />
        <CardText>

        {/*list of categories with title*/
          this.props.categories.map(cat => {
            let catTr = this.props.translation.categories.find((c) => c.engID === cat.id)
            let text = catTr ? catTr.title : ""
            return(
              <div key={"catTrTxtBoxDiv" + cat.id} style={{border: "solid 1px grey", padding: "0px 10px", borderRadius: 25, marginTop:5}}>
                <h4 style={{marginTop: 20, fontSize: 14, color: "black", fontWeight: '400', marginBottom:0}}>English Title</h4>
                <h5 style={{marginTop: 20, color: "black", fontWeight: '400', marginBottom:0}}>{cat.title.replace(/<.*?>/gm, '')}</h5>
                <h4 style={{marginTop: 20, color: "black", fontWeight: '400', marginBottom:0}}>Title Translation</h4>
                <TextField
                  style={{width: "100%"}}
                  ref={cat.id}
                  hintText="Category Title"
                  defaultValue={text}
                /><br />
              </div>
            )
          })
        }
        </CardText>
        <CardText>
          <CardActions expandable={true} style={{textAlign: "right"}}>
            <FlatButton onClick={this.cancel.bind(this)} label="cancel" />
              <RaisedButton onClick={this.submit.bind(this)} primary={true} label="Save" />
          </CardActions>
        </CardText>
      </Card>
    )
  }

  submit() {
      let trCats = Object.keys(this.refs).map(catID =>
        {return({
          engID: parseInt(catID),
          title: this.refs[catID].getValue()
        })}

      ).filter(c => c.title !== '')
      this.props.onSubmit(this.props.trID, trCats)
      this.props.router.goBack();

  }

  cancel() {
    this.goBack();
  }

  goBack() {
    this.props.router.goBack();
  }

}

const mapStateToProps = (state, ownProps) => {
  let trID = parseInt(ownProps.routeParams.trID)
  return {
    trID: trID,
    categories: state.categories.slice().filter((c) => c.type === 'question').sort(byTitle),
    translation: state.translations.find((t) => t.id === trID)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (trID, trCats) => {
      dispatch(saveCategoryTranslation(trID, trCats));
      dispatch(pushTranslation(trID, false))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TrCategories));
